import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { CREDENTIAL_MISMATCH } from "../../constants/globalConstants";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../../services";
import {
  decryptMessage,
  encryptMessage,
} from "../../services/encryption.decryption";
import toaster from "../../utilities/toaster";

export const getData = createAsyncThunk(
  "UI/person",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

//get all project names
export const getAdminAttendancePage = createAsyncThunk(
  "UI/getAdminAttendancePage",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.log(err);
      });
  }
);

//get all user types in the project
export const getUserInProject = createAsyncThunk(
  "UI/getUserInProject",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.log(err);
      });
  }
);

export const getMasterData = createAsyncThunk(
  "UI/getMasterConfig",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAttendance = createAsyncThunk(
  "UI/getAdminPageEngAttendance",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getAllMasterType = createAsyncThunk(
  "UI/getAllMasterType",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const getStpesData = createAsyncThunk(
  "UI/stepsData",
  ({ endPoint }: { endPoint: String }) => {
    return getRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postData = createAsyncThunk(
  "UI/login",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postAddMasterData = createAsyncThunk(
  "UI/addMasterData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const postUserByDesignation = createAsyncThunk(
  "UI/postUserDesignation",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const postData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return postRequest(endPoint, postData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const putData = createAsyncThunk(
  "UI/chnagePassword",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const editMasterData = createAsyncThunk(
  "UI/editMasterData",
  async ({ endPoint, data }: { endPoint: string; data: Object }) => {
    const putData =
      process.env.NODE_ENV === "development"
        ? { data }
        : { data: encryptMessage(JSON.stringify(data)) };
    return putRequest(endPoint, putData)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

export const deleteMasterData = createAsyncThunk(
  "UI/deleteMasterData",
  ({ endPoint }: { endPoint: String }) => {
    return deleteRequest(endPoint)
      .then((res) => res)
      .catch((err) => {
        console.error(err);
      });
  }
);

type SliceState = {
  loading: boolean;
  JwtToken: string;
  loginData: null | "" | Object;
  profileData: null | "" | Object;
  attendanceData: null | "" | Object;
  changePasswordData: null | "" | Object;
  rankData: null | "" | Object;
  stepsData: null | "" | Object;
  masterData: null | "" | Object;
  userByDesignation: null | "" | Object;
  allMasterType: null | "" | Object;
  deleteMasterData: null | "" | Object;
  addMasterData: null | "" | Object;
  editMasterData: null | "" | Object;
  usersByProject: null | "" | Object;
  adminAttendancePage: null | "" | Object;
};

const initialState: SliceState = {
  loading: false,
  JwtToken: "",
  loginData: "",
  profileData: "",
  attendanceData: "",
  changePasswordData: "",
  rankData: "",
  stepsData: "",
  masterData: "",
  userByDesignation: "",
  allMasterType: "",
  deleteMasterData: "",
  addMasterData: "",
  editMasterData: "",
  usersByProject: "",
  adminAttendancePage: "",
};

const slice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setToken(state, action) {
      state.JwtToken = action.payload;
    },
  },
  extraReducers: (builder) => {
    //TODO: Get API CALL START
    builder.addCase(getData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.profileData = data?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMasterData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.masterData = data;
      } else {
        console.log(data?.status);
        state.masterData = data;
      }
    });
    builder.addCase(getMasterData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getAdminAttendancePage.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAdminAttendancePage.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.adminAttendancePage = data;
      } else {
        console.log(data);
        state.adminAttendancePage = data;
      }
    });
    builder.addCase(getAdminAttendancePage.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get user by project API CALL START
    builder.addCase(getUserInProject.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getUserInProject.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.masterData = data;
      } else {
        console.log(data?.status);
        state.masterData = data;
      }
    });
    builder.addCase(getUserInProject.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get attendance in admin page API CALL START
    builder.addCase(getAttendance.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAttendance.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.masterData = data;
      } else {
        console.log(data?.status);
        state.masterData = data;
      }
    });
    builder.addCase(getAttendance.rejected, (state, action) => {
      console.log(action.payload);
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get all master type API CALL START
    builder.addCase(getAllMasterType.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getAllMasterType.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.allMasterType = data;
      } else {
        console.log(data?.status);
        state.allMasterType = data;
      }
    });
    builder.addCase(getAllMasterType.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Get API CALL START
    builder.addCase(getStpesData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getStpesData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.stepsData = data?.data[0]?.data;
      } else {
        console.log(data?.status);
      }
    });
    builder.addCase(getStpesData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Get API CALL END

    //TODO: Put API CALL START
    builder.addCase(putData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(putData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        // toaster("success", data?.message);
        state.changePasswordData = data;
      } else {
        toaster("error", data?.message);
        console.log(data?.status);
      }
    });
    builder.addCase(putData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Put API CALL START
    builder.addCase(editMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(editMasterData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        // toaster("success", data?.message);
        state.editMasterData = data;
      } else {
        // toaster("warning", data?.message);
        console.log(data?.status);
        state.editMasterData = data;
      }
    });
    builder.addCase(editMasterData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: Put API CALL END

    //TODO: Post API CALL START
    builder.addCase(postData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        if (data?.data?.role && data?.data?.role === "admin") {
          toaster("success", data?.message);
          sessionStorage.setItem("newToken", JSON.stringify(data?.token));
          state.JwtToken = data?.token;
        } else {
          toaster("error", CREDENTIAL_MISMATCH);
        }
      } else {
        toaster("error", data?.message);
        console.log(data.status);
      }
    });
    builder.addCase(postData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Post API CALL START
    builder.addCase(postUserByDesignation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postUserByDesignation.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        // toaster("success", data?.message);
        // toast.tostify("Logged in successfully");
        // sessionStorage.setItem("newToken", JSON.stringify(data?.token));
        state.userByDesignation = data;
      } else {
        // toaster("warning", data?.message);
        console.log(data.status);
        state.userByDesignation = data;
      }
    });
    builder.addCase(postUserByDesignation.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: Post API CALL START
    builder.addCase(postAddMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postAddMasterData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        // toaster("success", data?.message);
        // toast.tostify("Logged in successfully");
        // sessionStorage.setItem("newToken", JSON.stringify(data?.token));
        state.addMasterData = data;
      } else {
        // toaster("warning", data?.message);
        console.log(data.status);
        state.addMasterData = data;
      }
    });
    builder.addCase(postAddMasterData.rejected, (state) => {
      state.loading = false;
    });
    //TODO: Post API CALL END

    //TODO: DEL API CALL START
    builder.addCase(deleteMasterData.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deleteMasterData.fulfilled, (state, action) => {
      state.loading = false;
      const data: any =
        process.env.NODE_ENV === "development"
          ? action.payload?.data
          : decryptMessage(JSON.stringify(action.payload?.data));
      if (data?.status) {
        state.deleteMasterData = data;
      } else {
        console.log(data?.status);
        state.deleteMasterData = data;
      }
    });
    builder.addCase(deleteMasterData.rejected, (state) => {
      state.loading = true;
    });
    //TODO: DEL API CALL END
  },
});

export const uiActions = slice.actions;

export default slice;
